


































































































import Vue from 'vue'
import ModalSimple from '@/common/components/ModalSimple.vue'
import {
  TWITTER_SHARE_URL,
  FACEBOOK_SHARE_URL,
  LINE_SHARE_URL,
  TWITTER_SOCIAL_SHARE_MESSAGE,
  TWITTER_HASHTAGS,
  FACEBOOK_APP_ID
} from '@/common/constants'
import { queryString } from '@/common/queryString'
import { clipboardCopy } from '@/common/copy'
import { gaEventTracker, EVENT_CATEGORIES, EVENT_ACTIONS, EVENT_LABELS } from '@/common/utils'

export default Vue.extend({
  components: {
    ModalSimple
  },
  computed: {
    editorPage(): boolean {
      return this.$route.path == '/editor'
    },
    shareUrl(){
      return {
        PRODUCT_URL: window.location.origin + this.$route.fullPath,
        PAGE_TITLE: document.title
      }
    },
    twitterUrl(): string {
      const query = queryString.toString({
        text: encodeURIComponent(
          `${TWITTER_SOCIAL_SHARE_MESSAGE}\n${this.shareUrl.PAGE_TITLE}`
        ),
        url: encodeURIComponent(this.shareUrl.PRODUCT_URL),
        hashtags: TWITTER_HASHTAGS.join(',')
      })
      return `${TWITTER_SHARE_URL}?${query}`
    },
    facebookUrl(): string {
      const query = queryString.toString({
        app_id: FACEBOOK_APP_ID,
        display: 'popup',
        href: encodeURIComponent(this.shareUrl.PRODUCT_URL),
        redirect_uri: encodeURIComponent(this.shareUrl.PRODUCT_URL)
      })
      return `${FACEBOOK_SHARE_URL}?${query}`
    },
    emailUrl(): string{
      const formatEmailSubject = 'ラクスルアパレル・ユニフォームでご覧ください'
      const formatEmailBody = `ラクスルアパレル・ユニフォームで商品を見る \n ${this.shareUrl.PAGE_TITLE} \n ${this.shareUrl.PRODUCT_URL}`
      return `mailto:?subject=${formatEmailSubject}&body=${encodeURIComponent(formatEmailBody)}`
    },
    lineUrl(): string {
      const query = queryString.toString({
        url: encodeURIComponent(this.shareUrl.PRODUCT_URL)
      })
      return `${LINE_SHARE_URL}?${query}`
    },
    eventActions() {
      return EVENT_ACTIONS
    },
    eventCategory(): string {
      return this.editorPage ? EVENT_CATEGORIES.EDITOR : EVENT_CATEGORIES.PRODUCT_DETAIL
    }
  },
  methods: {
    closeModal() {
      this.$emit('onClose')
      this.eventTracker(EVENT_ACTIONS.CLOSE)
    },
    linkCopy() {
      clipboardCopy(this.shareUrl.PRODUCT_URL)
      this.eventTracker(EVENT_ACTIONS.LINK_COPY)
      alert('リンクをコピーしました')
    },
    eventTracker(action:string){
      gaEventTracker(
        this.eventCategory,
        action,
        EVENT_LABELS.SHARE_DIALOG
      )
    }
  }
})
